import { pageNumberState } from "@/atoms/order/page-number-state";
import { BasePageDto } from "@/types/dto/base-page-dto";
import { UserDto } from "@/types/dto/user-dto";
import { Pagination, Table } from "flowbite-react";
import React from "react";
import { useSetRecoilState } from "recoil";

interface Props {
  headers: any[];
  page: BasePageDto<UserDto>;
  handlePageChange: (currentPage: number) => void;
}

export const Footer: React.FC<Props> = ({
  headers,
  page,
  handlePageChange,
}) => {
  const setPageNumber = useSetRecoilState(pageNumberState);
  return (
    <Table.Row className="bg-white">
      <Table.Cell colSpan={headers.length}>
        <div className="flex justify-between">
          <div />
          <Pagination
            currentPage={page.currentPage}
            totalPages={page.totalPage}
            onPageChange={(currentPage: number) => {
              setPageNumber(currentPage);
            }}
            nextLabel=">"
            previousLabel="<"
          />
        </div>
      </Table.Cell>
    </Table.Row>
  );
};
